module.exports = __webpack_public_path__ + "static/media/date.2cd72f81.svg";